import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CartSharedModule} from '@spartacus/cart/base/components';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {MessageModule, TooltipModule} from 'ng-design-system';
import {ErrorIndicatorModule} from '@app/shared/error-indicator/error-indicator.module';
import {PurchaseOrderNumberModule} from '../checkout-purchase-order-number/purchase-order-number.module';
import {DcpCheckoutOrderSummaryComponent} from './dcp-checkout-order-summary.component';
import {IconButtonTooltipModule} from '@dcp/configurator';

import '@udex/web-components/dist/Tooltip';
import '@ui5/webcomponents/dist/Icon';

@NgModule({
    imports: [CommonModule,
        CartSharedModule,
        I18nModule,
        PurchaseOrderNumberModule,
        ConfigModule.withConfig({
            cmsComponents: {
                CheckoutOrderSummary: {
                    component: DcpCheckoutOrderSummaryComponent,
                }
            }
        }),
        ErrorIndicatorModule,
        TooltipModule,
        MessageModule, IconButtonTooltipModule,
    ],
  declarations: [DcpCheckoutOrderSummaryComponent],
  exports: [DcpCheckoutOrderSummaryComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
})
export class DcpCheckoutOrderSummaryModule {
}
